import React from 'react';
import { Spin } from 'antd';

// react functional component will invoke initially when app is in loading state
const LoadingScreen: React.FC = () => {
  return (
    <div
      style={{
        display: 'flex',
        height: '100vh',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Spin size="large" />
    </div>
  );
};
export default LoadingScreen;
